import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Opstina } from '../opstina/opstina';

@Component({
  selector: 'yt-opstina-modal-update',
  templateUrl: './opstina-modal-update.component.html'
})
export class OpstinaModalUpdateComponent extends BaseModalUpdateComponent<Opstina> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Opstina>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
